module.exports = __webpack_public_path__ + "assets/images/126f85b9fd418ad3fd8e80dc58a6dcf7.avif";